import { useGetEmployeeByDepartment } from '../services/api';
import { EmployeesTableSimple } from './EmployeesTableSimple';

export const DepartmentEmployeeTable: React.FC<{ departmentId: number }> = ({ departmentId }) => {
  const { data, error, isLoading } = useGetEmployeeByDepartment({ departmentId });
  return <EmployeesTableSimple data={data} isLoading={isLoading} error={error} />;
};
